var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    attrs: {
      id: "template-email-modal",
      "loaders-disabled": "",
      "modal-dialog-size": "lg",
    },
    on: { hidden: _vm.handleHidden },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("email.savedTemplateEmails")) + "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "row pt-1 clients-row form-page client" },
              [
                _vm.hasTemplates
                  ? _c("div", { staticClass: "col-12 mb-2 sticky-top" }, [
                      _c("div", { staticClass: "right-inner-addon w-50" }, [
                        _c("i", {
                          staticClass: "fa fa-search",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.searchString,
                              expression: "searchString",
                              modifiers: { trim: true },
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "search-string",
                            type: "search",
                            placeholder: _vm.$t("email.searchForTemplates"),
                            autocomplete: "off",
                          },
                          domProps: { value: _vm.searchString },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.searchString = $event.target.value.trim()
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "d-none",
                            attrs: { for: "search-string" },
                          },
                          [_vm._v("$t('email.searchForTemplates')")]
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _vm.hasTemplates && _vm.hasFilteredTemplates
                    ? _c(
                        "table",
                        {
                          staticClass: "display table-clients flex-table",
                          staticStyle: { width: "100%" },
                          attrs: { id: "timeline-email-list" },
                        },
                        [
                          _c("thead", [
                            _c(
                              "tr",
                              {
                                staticClass: "d-flex py-2",
                                staticStyle: { padding: "0.75rem" },
                              },
                              [
                                _c("th", {
                                  staticClass: "theader theader-big col-1",
                                  attrs: { scope: "col" },
                                }),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass: "theader theader-big col-2",
                                    attrs: { scope: "col" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("global.words.name")) +
                                        "\n                "
                                    ),
                                    _c("i", {
                                      staticClass: "fa fa-caret-down",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass: "theader theader-big col-3",
                                    attrs: { scope: "col" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("global.words.description")
                                        ) +
                                        "\n                "
                                    ),
                                    _c("i", {
                                      staticClass: "fa fa-caret-down",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass: "theader theader-big col-2",
                                    attrs: { scope: "col" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("global.words.subject")) +
                                        "\n                "
                                    ),
                                    _c("i", {
                                      staticClass: "fa fa-caret-down",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass: "theader theader-big col-2",
                                    attrs: { scope: "col" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("email.saveDate")) +
                                        "\n                "
                                    ),
                                    _c("i", {
                                      staticClass: "fa fa-caret-down",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass: "theader theader-big col-1",
                                    attrs: { scope: "col" },
                                  },
                                  [
                                    _c("span", { staticClass: "d-none" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("email.customFieldsTags.LABEL")
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass: "theader theader-big col-1",
                                    attrs: { scope: "col" },
                                  },
                                  [
                                    _c("span", { staticClass: "d-none" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("email.customFieldsTags.LABEL")
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            { staticClass: "card no-borders box" },
                            _vm._l(_vm.filteredEmailTemplates, function (ref) {
                              var name = ref.name
                              var description = ref.description
                              var subject = ref.subject
                              var attachments = ref.attachments
                              var createdAt = ref.createdAt
                              var id = ref.id
                              return _c(
                                "tr",
                                { key: id, attrs: { role: "row" } },
                                [
                                  _c("td", { staticClass: "col-1" }, [
                                    attachments && attachments.length
                                      ? _c("i", {
                                          staticClass: "fa fa-paperclip ml-2",
                                          staticStyle: { "font-size": "150%" },
                                          attrs: { "aria-hidden": "true" },
                                        })
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "col-2" }, [
                                    _c(
                                      "h4",
                                      {
                                        staticClass:
                                          "regular text-light-gray my-auto mx-auto",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(name) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "col-3" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "regular my-auto mx-auto font-xs",
                                        staticStyle: {
                                          color: "#767676 !important",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(description) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "col-2" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "regular my-auto mx-auto font-xs",
                                        staticStyle: {
                                          color: "#767676 !important",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(subject) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "col-2" }, [
                                    _c(
                                      "h4",
                                      {
                                        staticClass:
                                          "regular text-light-gray my-auto mx-auto text-capitalize",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm._f("formatDate")(createdAt)
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "col-1 d-flex justify-content-center",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "clickable load-template btn bold btn-white btn-sm",
                                          on: {
                                            click: function ($event) {
                                              return _vm.loadTemplate(id)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "margin-left": "0.1em",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("global.actions.load")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "col-1" },
                                    [
                                      _c(
                                        "inline-prompt",
                                        {
                                          staticClass:
                                            "clickable text-danger delete-template",
                                          staticStyle: {
                                            "font-size": "0.8rem",
                                          },
                                          attrs: {
                                            "action-type": "delete",
                                            placement: "left",
                                            "confirmation-text":
                                              "i18n|global.actions.confirmDelete",
                                          },
                                          on: {
                                            accept: function ($event) {
                                              return _vm.deleteTemplate(id)
                                            },
                                          },
                                        },
                                        [
                                          _c("icon", {
                                            staticClass: "text-danger",
                                            attrs: { name: "trash" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    : _c("div", { staticClass: "row mt-5 pl-5" }, [
                        _c("div", { staticClass: "col-12 text-center" }, [
                          _c("img", {
                            attrs: {
                              height: "80px",
                              src: require("@Broker/@Assets/icon/empty-timeline.png"),
                              alt: "",
                            },
                          }),
                          _vm._v(" "),
                          _c("h4", { staticClass: "text-gray mt-2" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("campaigns.thereAreNoTemplates")
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                      ]),
                ]),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }